import PopupBasic from 'src/game/components/popups/PopupBasic';
import i18n from 'src/lib/i18n/i18n';
import uiConfig from 'src/lib/ui/config';
import ButtonScaleViewWithText from 'src/lib/ui/components/ButtonScaleViewWithText';
import View from '@play-co/timestep-core/lib/ui/View';
import sounds from 'src/lib/sounds';
import { Feature } from 'src/replicant/analytics';
import StateObserver from 'src/StateObserver';
import { openNativeAppStorePage } from '../native.util';
import { AssetGroup } from '@play-co/timestep-core';
import { ImageScaleView } from '@play-co/timestep-core/ui';
import { downscale } from 'src/conf/scale';
import popups from 'src/lib/ui/config/popups';

const ui = uiConfig.buruburu.invite.confirm;

export default class PopupUpdateAppSoft extends PopupBasic {
  constructor(opts: { superview: View; close: VoidFunction }) {
    super({
      superview: opts.superview,
      close: () => opts.close(),
      zIndex: 10000,
      width: popups.buruburu.width,
      height: 750,
      darkerBg: false,
      tracking: {
        feature: Feature.NATIVE._,
        $subFeature: Feature.NATIVE.UPDATE_APP_POPUP_SOFT,
      },
    });

    new ImageScaleView({
      superview: this.box,
      image: 'assets/ui/updateApp/update_app.png',
      width: downscale(785),
      height: downscale(525),
      x: this.box.style.width / 2,
      y: 270,
      centerOnOrigin: true,
    });

    this.message.updateOpts({
      ...ui.message,
      width: this.box.style.width - 60,
      height: 150,
      x: 30,
      y: 450,
    });

    new ButtonScaleViewWithText({
      ...ui.okButton,
      superview: this.box,
      centerOnOrigin: true,
      x: this.box.style.width / 2,
      y: this.box.style.height - 90,
      width: 300,
      localeText: () => i18n('native.updateSoft.cta'),
      onClick: async () => {
        sounds.sfx.play('ok');
        openNativeAppStorePage({
          tracking: {
            origin: 'launch',
            feature: Feature.NATIVE._,
            subFeature: Feature.NATIVE.UPDATE_APP_POPUP_SOFT,
            timestamp: StateObserver.now(),
          },
        });
      },
      tracking: {
        feature: Feature.NATIVE._,
        $subFeature: Feature.NATIVE.UPDATE_APP_POPUP_SOFT_CTA,
      },
    });
  }

  protected getAssetsGroup() {
    return new AssetGroup(AssetGroup.constructURLs(['assets/ui/updateApp/']));
  }

  public init(opts: { hardUpdate: boolean }) {
    super.init({
      title: i18n('native.updateSoft.title'),
      message: i18n('native.updateSoft.body'),
    });

    if (opts.hardUpdate) {
      this.buttonClose.removeFromSuperview();
    }
  }
}
